// @flow
import React from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'

import './styles.css'
import { Link } from 'react-router-dom'

const successMessage = props => {
  const {
    name,
    email,
    numberOfRefferals
  } = props.location.state
  return (
    <Grid fluid>
      <Row center='xs'>
        <Col className='main-container' xs={12} sm={12} md={12} lg={9}>
          <Row center='xs'>
            <Col className='wink-top-logo' />
          </Row>
          <Row center='xs'>
            <Col className='tittle'>
              ¡Gracias {name}!
            </Col>
          </Row>
          <Row>
            <Col
              className='message'
              style={{ marginTop: 30 }}
              smOffset={1}
              xs={12} sm={10} md={10} lg={10}
            >
              Acabás de invitar a {numberOfRefferals} contacto{numberOfRefferals === 1 ? ' ' : 's '}
              a usar Wink. Cada vez que uno de estos contactos cree una cuenta en Wink y solicite la tarjeta quedarás participando en la promoción que te enviamos por correo.
              Si tenés cualquier consulta podés escribirnos a <a href='https://soporte.holawink.com/' rel='noopener noreferrer'
                target='_blank'>Servicio al Cliente</a>.
            </Col>
          </Row>
          <Row center='xs'>
            <button
              className='submit-btn'
              style={{ marginTop: 0 }}
              onClick={() => props.history.push(`/referral/${name}/${email}`)}
            >
              ENVIAR MÁS INVITACIONES
            </button>
          </Row>
        </Col>
      </Row>
    </Grid>
  )
}

export default successMessage



// WEBPACK FOOTER //
// ./src/pages/Referral/success.js